import { ColorPalette } from '@wordpress/block-editor';
import { PanelBody, ToggleControl, HorizontalRule, RangeControl } from '@wordpress/components';
import { __ } from '@wordpress/i18n';

export const TopShapePanel = ({ attributes, setAttributes }) => {
    const { showTopShape, topShapeWidth, topShapeHeight, topFlipX, topFlipY, topShapeColor } = attributes;
    
    return (
        <PanelBody title={__('Top Shape', 'fse-blocks')}>
            <div className="top-shape-psettings">
                <ToggleControl
                    label={__('Show Top Shape', 'fse-blocks')}
                    help={
                        showTopShape
                            ? __('Top shape is visible.', 'fse-blocks')
                            : __('Top shape is hidden.', 'fse-blocks')
                    }
                    checked={showTopShape}
                    
                    onChange={(NewValue)=>{setAttributes({showTopShape:NewValue})}}
                />
                {showTopShape && 
                <>
                <HorizontalRule />
                <RangeControl 
                    min={100} max={300} value={topShapeWidth || 100} onChange={(newValue)=>{setAttributes({topShapeWidth:parseInt(newValue)})}} label={__('Width', 'fse-blocks')} />
                <RangeControl 
                    min={0} max={200} value={topShapeHeight} onChange={(newValue)=>{setAttributes({topShapeHeight:parseInt(newValue)})}} label={__('Height', 'fse-blocks')} />
                <HorizontalRule />
               <ToggleControl
                    label={__('Flip Horizontal', 'fse-blocks')}
                    checked={topFlipX}
                    onChange={(NewValue)=>{setAttributes({topFlipX:NewValue})}}
                />
                <ToggleControl
                    label={__('Flip Vertical', 'fse-blocks')}
                    checked={topFlipY}
                    onChange={(NewValue)=>{setAttributes({topFlipY:NewValue})}}
                />
                <HorizontalRule />
                <div>
                    <label>{__('Shape Color', 'fse-blocks')}</label>
                    <ColorPalette
                        value={topShapeColor}
                        onChange={(NewValue)=>{setAttributes({topShapeColor:NewValue})}}
                    />
                </div>

                </>
                }
            </div>
        </PanelBody>
    );
};

 export default TopShapePanel;